'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledText = require('../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actionIcon = require('../action-icon');

var _actionIcon2 = _interopRequireDefault(_actionIcon);

var _constants = require('./constants');

var _AlertTriangleIcon = require('../../icons/AlertTriangleIcon');

var _ArrrowDownIcon = require('../../icons/ArrrowDownIcon');

var _CheckCircleIcon = require('../../icons/CheckCircleIcon');

var _InfoCircleIcon = require('../../icons/InfoCircleIcon');

var _XIcon = require('../../icons/XIcon');

var _palette = require('../../palette');

require('./alert-banner.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var images = [{
  type: _constants.ARROWDOWNINFO,
  src: _ArrrowDownIcon.ArrrowDownIcon
}, {
  type: _constants.OK,
  src: _CheckCircleIcon.CheckCircleIcon
}, {
  type: _constants.INFO,
  src: _InfoCircleIcon.InfoCircleIcon
}, {
  type: _constants.ERROR,
  src: _AlertTriangleIcon.AlertTriangleIcon
}];
var STYLE_BASE = 'zk-alert-banner-';

var AlertBanner = function (_Component) {
  _inherits(AlertBanner, _Component);

  function AlertBanner() {
    _classCallCheck(this, AlertBanner);

    return _possibleConstructorReturn(this, (AlertBanner.__proto__ || Object.getPrototypeOf(AlertBanner)).apply(this, arguments));
  }

  _createClass(AlertBanner, [{
    key: 'getIconStyle',
    value: function getIconStyle(type) {
      switch (type) {
        case _constants.OK:
          return _palette.successBannerColor;

        case _constants.ARROWDOWNINFO:
          return _palette.arrowIconColor;

        case _constants.INFO:
          return _palette.zipwhipOrange;

        case _constants.ERROR:
          return _palette.errorColor;

        default:
      }
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          _props$type = _props.type,
          type = _props$type === undefined ? '' : _props$type,
          _props$error = _props.error,
          error = _props$error === undefined ? false : _props$error,
          imageWrapperStyle = _props.imageWrapperStyle; // go with type if it is there else fallback for backwards compatibility.

      var imageType = type;

      if (!imageType) {
        imageType = error ? _constants.ERROR : _constants.OK;
      } // hiding the images when they are not needed to deal with weird image loading
      // on mobile browsers.


      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'image-wrapper', true), _defineProperty(_classNames, imageWrapperStyle, !!imageWrapperStyle), _classNames))
      }, images.map(function (img, index) {
        var ImageToShow = img.src;
        return _react2.default.createElement('div', {
          key: index,
          className: imageType === img.type ? STYLE_BASE + 'image' : STYLE_BASE + 'hidden-image'
        }, _react2.default.createElement(ImageToShow, {
          color: _this2.getIconStyle(imageType)
        }));
      }));
    }
  }, {
    key: 'getWrapperStyle',
    value: function getWrapperStyle() {
      var _props2 = this.props,
          className = _props2.className,
          type = _props2.type,
          error = _props2.error,
          _props2$inline = _props2.inline,
          inline = _props2$inline === undefined ? false : _props2$inline;
      var wrapperStyle = {};

      if (className) {
        wrapperStyle[className] = true;
      }

      switch (type) {
        case _constants.OK:
          wrapperStyle[STYLE_BASE + 'success-message'] = true;
          break;

        case _constants.ARROWDOWNINFO:
        case _constants.INFO:
          wrapperStyle[STYLE_BASE + 'info-message'] = true;
          break;

        case _constants.ERROR:
          wrapperStyle[STYLE_BASE + 'failure-message'] = true;
          break;

        default:
          wrapperStyle[error ? STYLE_BASE + 'failure-message' : STYLE_BASE + 'success-message'] = true;
          break;
      }

      wrapperStyle[STYLE_BASE + 'inline'] = inline;
      return (0, _classnames2.default)(wrapperStyle);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          message = _props3.message,
          testID = _props3.testID,
          onClose = _props3.onClose,
          noClose = _props3.noClose,
          style = _props3.style;
      return _react2.default.createElement('div', {
        className: this.getWrapperStyle(),
        'data-testid': testID,
        style: style
      }, this.getImage(), children ? _react2.default.createElement('div', {
        className: STYLE_BASE + 'banner-view'
      }, children) : _react2.default.createElement(_styledText2.default, {
        className: STYLE_BASE + 'banner-view'
      }, message), !noClose && _react2.default.createElement('div', {
        className: STYLE_BASE + 'close-icon-wrapper'
      }, _react2.default.createElement(_actionIcon2.default, {
        Icon: _XIcon.XIcon,
        onClick: onClose,
        className: STYLE_BASE + 'close-icon'
      })));
    }
  }]);

  return AlertBanner;
}(_react.Component);

AlertBanner.propTypes = {
  className: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  testID: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  type: _propTypes2.default.string,
  noClose: _propTypes2.default.bool,
  inline: _propTypes2.default.bool
};
AlertBanner.defaultProps = {
  error: false,
  testID: 'STATUS_UPDATE_BOX',
  type: ''
};
exports.default = AlertBanner;